import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import scrollIntoView from "scroll-into-view-if-needed";
import TabsCarousel from "Components/TabsCarousel";
import Swal from "sweetalert2";
import {
  Row,
  Col,
  Radio,
  Space,
  Divider,
  Button,
  Modal,
  message,
  Rate,
  Form,
  Input,
  Menu,
  Layout,
  Drawer,
  Card,
} from "antd";
import Diagnosis from "./NewDiagnosis";
import TreatmentPlan from "./TreatmentPlan";
import { ArrowLeftOutlined, CheckOutlined } from "@ant-design/icons";
// import VideoConsultationVideoChild from "./VideoConsultationVideoChild";
import PrescriptionTab from "./PrescriptionTab";
import DoctorDescription from "./DoctorDescription";
import "./Consultation.scss";
import "./ChimeVideoConsultation.scss";
import { withRouter } from "react-router-dom";
import { setUpdateData } from "store/slice/videoConsultation-slice";
const { LocalDataTrack, connect: connects } = require("twilio-video");
import api from "utils/api";
import utils from "utils";
import CaseNotes from "./CaseNotes";
import {
  setPrescriptionDone,
  setMinvideoVisible,
  setPrescriptions,
  setVideoFullScreen,
} from "store/slice/videoConsultation-slice";
import { switchVCTab, currentTab } from "store/slice/tabs-slice";
import FollowUp from "./FollowUp";
import DoctorReferral from "./DoctorReferral";
import Stress from "./Stress";
import Loader from "Components/Loader";
import Validators from "Common/Validators";
import MultiDocUploadTab from "./MultipleDocUploadTab";
import VideoConsultationConversation from "./VideoConsultationConversation";
import { CONSTANTS } from "utils/constant";
import FinishConsultation from "./FinishConsultation";
import CommonButton from "Components/CommonButton";
import VitalFormDoctorAtConsultation from "Pages/VitalForm/VitalFormDoctorAtConsultation";
import ChimeMeetingPanel from "Pages/MyProfile/ChimeMeetingPanel";
import ChimeVideoConsultationVideoChild from "./ChimeVideoConsultationVideoChild";
import ChimeSpeechToAIForm from "./AIForm/ChimeSpeechToAIForm";
import { Roundcheck } from "Common/ReactIcons";
import { RoundcheckGreen } from "Common/ReactIcons";
const { Content, Sider } = Layout;

class ChimeVideoConsultation extends React.Component {
  _isMounted = false;
  _isJoined = false;

  constructor(props) {
    super(props);
    let {
      gender: gender,
      user_type,
      remoteusr: remoteUser,
      appointment_date,
      roomName: appointment_id,
      localusr: localUser,
      appointment_patient_is_evaluated: patientEvaluated,
      is_multiple_session = true,
      age: age,
      is_video_call: is_video_call,
    } = this.props?.location?.state || {};

    this.state = {
      tabLabel: "",
      isMeetingActive: false,
      minvideoVisible: false,
      timerOn: false,
      timerStart: 0,
      timerTime: 0,
      totalTime: 0,
      clinicalRatingValue: 0,
      callRatingValue: 0,
      comments: "",
      errorMessage: "",
      isValid: true,
      feebackBtnLoading: false,
      showChat: false,
      consultation_info: {
        remoteUser,
        appointment_date,
        patientEvaluated,
        is_multiple_session,
        appointment_id,
        localUser,
        gender,
        user_type,
        age,
        is_video_call,
      },
      value: 1,
      prescriptionValue: 2,
      casesheetValue: 1,
      consultationValue: 1,
      activeTab: 0,
      identity: "",
      roomName: "",
      room: null,
      recievedToken: {
        identity: "",
        token: "",
        roomName: "",
      },
      isRmtPrtcptJoined: false,
      reloadRmtPrtcptConvo: false,
      prescriptions: this.props.prescriptions || [],
      doctorAvaliableDates: [],
      doctorAvaliableSlots: [],
      selectedSlot: "",
      is_prescription: false,
      is_prescription_done: false,
      is_evaluation_publish: false,
      is_psychiatry_fb_report: false,
      is_caseFormulation1: false,
      is_caseFormulation2: false,
      is_casenotes: false,
      is_edit: false,
      isModalVisible: false,
      totalDuration: 0,
      istabVisible: true,
      noPrescription: 1,
      predefinedPrescription: [],
      predefinedPrescriptionSet: [],
      is_casesheet: false,
      is_dsm: false,
      is_mhe: false,
      is_theraphy: false,
      is_protective_factor: false,
      is_dot: false,
      is_sos: false,
      is_update: {},
      autoNoConsultation: true,
      autoNoReferral: true,
      prescription_enable: false,
      loading: false,
      is_prescription_required: true,
      ButtonLists: [
        {
          key: "vital",
          label: "Vitals",
          apikey:"is_vital",
        },
        {
          key: "Case Sheets",
          label: "Case Sheets",
          apikey:"is_casesheet",
        },
        {
          key: "Diagnosis",
          label: "Diagnosis",
          apikey:"is_diagnosis",
        },
        {
          key: "Prescription",
          label: "Prescription",
          apikey:"is_prescription_done",
        },
        {
          key: "Follow Up",
          label: "Follow Up",
          apikey:"is_followup_consultation",
        },
        {
          key: "Doctor Referral",
          label: "Doctor Referral",
          apikey:"is_doctor_referral",
        },
      ],
      is_show_ai_form: false,
      is_show_drawer: false,
      attendeeData: this.props.location.state.attendeeData,
      meetingData: this.props.location.state.meetingData,
    };
    this.form = React.createRef();
    this.getToken = this.getToken.bind(this);
    this.onCheckCasesheet = this.onCheckCasesheet.bind(this);
    this.onCheckConsultation = this.onCheckConsultation.bind(this);
    this.videoCont = React.createRef();
  }

  toggleChat = (value) => {
    const current = this.state.showChat;
    this.setState({ showChat: !current });
    this.props.setVideoFullScreen(!current);
  };
  toggleAIForm = () => {
    this.setState((prevState) => ({
      is_show_ai_form: !prevState.is_show_ai_form,
    }));
  };
  toggleDrawerForm = () => {
    this.setState((prevState) => ({
      is_show_drawer: !prevState.is_show_drawer,
    }));
  };
  disablePrescription = (value) => {
    this.setState({ prescription_enable: value, prescriptionValue: 2 });
  };
  // handleDoctorSelection(item, index) {
  //   this.getConsultationStatus();
  //   this.setState({
  //     activeTab: index,
  //     tabLabel: item.label,
  //   });
  // }
  getToken = () => {
    let identity = this.props.location.state.identity;
    let token = this.props.location.state.token;
    let roomName = this.props.location.state.roomName;
    this.state.recievedToken.identity = identity;
    this.state.recievedToken.token = token;
    this.state.recievedToken.roomName = roomName;
    if (this.state.recievedToken.token === null) {
      this.props.history.goBack();
    }
    return this.state.recievedToken.token;
  };
  getConsultationStatus() {
    api
      .get_consultation_status({
        appointment_id: this.props.location.state?.roomName,
      })
      .then((response) => {
        this.setState({
          is_prescription_done: response.data.data.is_prescription,
          is_evaluation_publish: response.data.data.is_evaluation_report,
          is_casesheet: response.data.data.is_casesheet,
          is_dsm: response.data.data.is_dsm,
          is_mhe: response.data.data.is_mhe,
          is_theraphy: response.data.data.is_theraphy,
          is_doctor_referral: response.data.data.doctor_referral,
          autoNoConsultation: !response.data.data.is_followup_consultation,
          is_protective_factor: response.data.data.is_protective_factor,
          is_dot: response.data.data.is_dot,
          is_sos: response.data.data.is_sos,
          is_diagnosis: response.data.data.is_diagnosis,
          is_caseFormulation1: response.data.data.is_case_formulation1,
          is_caseFormulation2: response.data.data.is_case_formulation2,
          is_caseFormulation2: response.data.data.is_case_formulation2,
          is_prescription_required: response.data.data.is_prescription_required,
          is_prescription_report: response.data.data.is_prescription_report,
          is_prescription_publish_status:
            response.data.data.prescription_publish_status,
          is_psychiatry_fb_report: response.data.data.is_psychiatry_fb_report,
          is_vital:response.data.data.is_vital,
          is_followup_consultation:response.data.data.is_followup_consultation,
        });
        this.props.setUpdateData(response.data.data);

        if (!this.state.autoNoConsultation) {
          this.setState({ consultationValue: 2 });
        }
      })
      .catch((err) => {});
  }
  handleClinicalRatingsChange = (value) => {
    this.setState({ clinicalRatingValue: value });
    this.form.current?.setFieldsValue({
      feedback_rating: this.state.clinicalRatingValue,
    });
  };
  handleCallRatingsChange = (values) => {
    this.setState({ callRatingValue: values });
    this.form.current?.setFieldsValue({
      call_rating: this.state.callRatingValue,
    });
  };
  handleComment(e) {
    this.setState({ comments: e.target.value });
  }
  getDoctorReferral() {
    api
      .get_consultation_details({
        app_id: this.props.location.state?.roomName,
        type: "doctor_referral",
      })
      .then((response) => {
        let data =
          response.data?.data?.results?.doctor_referral[0]
            ?.referral_comments[0];
        if (data.new_doctor_name) {
          this.setState({
            autoNoReferral: false,
            followup_data: {
              name: data?.new_doctor_name,
              comments: data?.doctor_comments,
            },
          });
        }
        this.formReferal.current?.setFieldsValue({
          comments: data?.doctor_comments,
          speciality_doctor: data?.new_doctor_name,
        });
      })
      .catch((err) => {});
  }
  componentDidMount = async () => {
    const ButtonLists = [
      {
        key: "vital",
        label: "Vitals",
        apikey:"is_vital",
      },
      {
        key: "Case Sheets",
        label: "Case Sheets",
        apikey:"is_casesheet",
      },
      {
        key: "Diagnosis",
        label: "Diagnosis",
        apikey:"is_diagnosis",
      },
      {
        key: "Prescription",
        label: "Prescription",
        apikey:"is_prescription_done",
      },
      {
        key: "Follow Up",
        label: "Follow Up",
        apikey:"is_followup_consultation",
      },
      {
        key: "Doctor Referral",
        label: "Doctor Referral",
        apikey:"is_doctor_referral",
      },
    ];
    if (
      this.state.consultation_info.patientEvaluated == false ||
      !this.state.consultation_info.is_multiple_session
    ) {
      this.setState({
        ButtonLists,
      });
    };
    if(this.props.location?.state?.is_doctor)
      {this.getConsultationStatus();}
    this.reJoin()
      .then(() => {
        this._isJoined = true;
        this.startTimer();
      })
      .catch((err) => {
        console.log(err);
      });
    // this.startTimer();
    // if (this._isMounted) {
    // this._isJoined = true;
    // }
    localStorage.setItem(
      "patient_user_type",
      this.props.location.state?.user_type || ""
    );
    localStorage.setItem(
      "patient_gender",
      this.props.location.state?.gender || ""
    );
    // window.addEventListener("scroll", this.listenToScroll, true);
  };

  reJoin = async () => {
    let payloadData = {
      app_id: this.props.location.state?.roomName,
      type: this.props.location.state.is_doctor ? "doctor" : "patient",
    };
    try {
      const response = await api.get_meeting_details(payloadData);
      if (response.data.status === 200) {
        this.setState(
          {
            meetingData: response?.data?.data?.Meeting,
            attendeeData: response?.data?.data?.Attendees,
          },
          () => {
            this.setState({ isMeetingActive: true });
          }
        );
        return response;
      } else {
        message.warning(response.data.message);
        this.props.history.goBack();
        return null;
      }
    } catch (err) {
      console.log(err);
      // throw err;
    }
    // try {
    //   let token = this.state.token;
    //   const room = await connects(token, {
    //     name: this.state.recievedToken.roomName,
    //     audio:
    //       process.env.REACT_APP_ENV == "dev" ||
    //       process.env.REACT_APP_ENV == "test" ||
    //       !this.state.consultation_info?.is_video_call
    //         ? false
    //         : true,
    //     video:
    //       process.env.REACT_APP_ENV == "dev" ||
    //       process.env.REACT_APP_ENV == "test" ||
    //       !this.state.consultation_info?.is_video_call
    //         ? false
    //         : true,
    //   });
    //   this.setState({ room: room });
    //   room.on("trackSubscribed", (track) => {
    //     if (track.kind == "data") {
    //       this.setState({ reloadRmtPrtcptConvo: true });
    //     }
    //   });
    // } catch (err) {
    //   let data = {
    //     app_id: this.props.location.state?.roomName,
    //     type: this.props.location.state?.type,
    //     status: "Failure",
    //   };
    //   api
    //     .submit_preflight_error(data)
    //     .then((res) => {})
    //     .catch((err) => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       Swal.fire("Error Loading Page!", err + "!", "error").then((value) => {
    //         this.props.history.goBack();
    //       });
    //       console.log("This err is from VideoConsultation Rejoin", err);
    //     });
    // }
  };
  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.prescriptions !== this.state.prescriptions) {
  //     console.log("updated", this.state.prescriptions)
  //     this.setState({noPrescription: 2})
  //   }
  // }

  listenToScroll = () => {
    if (this.state.room === null) return;
    const winScroll =
      document?.body?.offsetHeight || document?.documentElement?.offsetHeight;
    const posVideo = this.videoCont?.current?.getBoundingClientRect();
    if (posVideo.height + posVideo.top < 275) {
      this.props.setMinvideoVisible(true);
      // this.setState({
      //   minvideoVisible: true,
      // });
    } else {
      this.props.setMinvideoVisible(false);
    }
  };
  componentWillUnmount() {
    this._isMounted = false;
    localStorage.setItem("reloadPrescription", true);
    window.removeEventListener("scroll", this.listenToScroll, true);
  }
  startTimer = () => {
    this.setState({
      timerOn: true,
      timerTime: this.state.timerTime,
      timerStart: Date.now() - this.state.timerTime,
    });
  };
  stopTimer = () => {
    this.setState({ timerOn: false });
    clearInterval(this.timer);
  };
  resetTimer = () => {
    this.setState({
      timerStart: 0,
      timerTime: 0,
    });
  };
  returnToLobby = (totalDuration, sid) => {
    // this.setState({ room: null });
    this.setState({ isMeetingActive: false });
    this.setState({
      isModalVisible: true,
      totalDuration: totalDuration,
    });
    // if (this.props.location.state?.is_doctor) {
    //   let data = {
    //     appointment_id: this.props.location.state?.roomName,
    //     room_id: sid,
    //   };
    //   this.state.room &&
    //     api
    //       .submit_composition_response_update(data)
    //       .then((res) => {
    //         if (res.data?.status == 200) {
    //           // console.log(res.data?.message);
    //         }
    //       })
    //       .catch((err) => {});
    // }
  };

  onprescriptionRadioChange = (e) => {
    this.setState({
      prescriptionValue: e.target.value,
    });
    if (e.target.value === 1) {
      this.setState({ noPrescription: 1 });
    } else {
      this.setState({ noPrescription: 2 });
    }
  };
  onCasesheetRadioChange = (e) => {
    this.setState({
      casesheetValue: e.target.value,
    });
    if (this.state.casesheetValue === 2) {
      this.formCasesheet.current?.resetFields();
    }
  };
  onConsultationRadioChange = (e) => {
    this.setState({
      consultationValue: e.target.value,
    });
  };

  formAction = (value) => {
    this.setState({ form_action: value });
  };
  onCheckCasesheet = () => {
    if (this.state.casesheetValue === 1) {
      return false;
    } else {
      return true;
    }
  };
  onCheckConsultation = () => {
    if (this.state.consultationValue === 1) {
      return false;
    } else {
      return true;
    }
  };
  success = () => {
    this.setState({
      isModalVisible: true,
    });
  };
  handleOk = () => {
    this.setState({
      isModalVisible: false,
    });
    if (this.props.location.state?.is_doctor === true) {
      this.setState({ istabVisible: false });
    } else {
      this.props.history.goBack();
    }
  };
  handleSubmitFeedback() {
    this.setState({ feebackBtnLoading: true });
    api
      .feedback_rating({
        appointment_id: this.props.location.state?.roomName || "",
        clinician_rating: this.state?.clinicalRatingValue || "",
        brand_rating: this.state?.callRatingValue || "",
        comments: this.state?.comments || "",
      })
      .then((response) => {
        let data = response?.data?.data?.results;
        this.setState({ feedbackData: data, isModalVisible: false });
        if (response?.status == 200) {
          message.success(response?.data?.message, ErrorDuration);
          this.setState({ feebackBtnLoading: false });
          this.props.history.goBack();
        } else {
          message.error("Cannot submit empty form.", ErrorDuration);
          this.setState({ feebackBtnLoading: false });
        }
      });
  }
  handleCancel = () => {
    this.handleOk();
  };
  closeConsultation = () => {
    utils.Modal(false);
    this.setState({ loading: true });
    setTimeout(() => {
      if (this.state.autoNoConsultation) {
        let consultationFormData = {
          appointment_id: this.props.location.state.roomName,
          appointment_date_time: "",
          next_consultation: false,
        };
        api
          .next_consultation_submit(consultationFormData)
          .then((res) => {
            if (res.data?.status == 200) {
              this.closeConsultationResponse();
            } else {
              this.closeConsultationResponse();
            }
          })
          .catch((err) => {});
      } else {
        this.closeConsultationResponse();
      }
    }, 1000);
  };
  closeConsultationResponse = () => {
    let closeAppointmentFormData = {
      appointment_id: this.props.location.state.roomName,
      is_prescription: !this.state.is_prescription_required
        ? false
        : this.state.is_prescription_done || this.state.is_prescription,
      is_prescription_required: this.state.is_prescription_required,
      is_casenotes: this.state.is_casenotes,
      // prescription_mail:
      //   this.state.is_prescription_done || this.state.is_prescription,
      is_appointment_missed: false,
    };
    api
      .close_appointment_submit(closeAppointmentFormData)
      .then((res) => {
        if (res.data?.status == 200) {
          message.success(res.data?.message, ErrorDuration);
          this.props.history.goBack();
        }
      })
      .catch((err) => {});
  };
  finishConsultation = () => {
    api
      .get_consultation_status({
        appointment_id: this.props.location.state?.roomName,
      })
      .then((res) => {
        utils.Modal(true, {
          width: "950px",
          content: (
            <div
              style={{ height: "fit-content" }}
              className="finish-Consult-Modal"
            >
              <div className="finish-header">
                {CONSTANTS.FINISH_CONSULTATION}
              </div>
              <div
                style={{ display: "grid", gap: "8px" }}
                className="finish-wrapper"
              >
                <div className="finish-title">
                  {CONSTANTS.FINISH_CONSULTATION_HEADING}
                </div>
                <FinishConsultation
                  type_user={this.state.consultation_info?.user_type}
                  prescription_done={
                    res.data.data.is_prescription ||
                    res.data.data.is_medical_test_report
                  }
                  evaluation_publish={res.data.data.is_evaluation_report}
                  case_notes={res.data.data.is_casesheet}
                  dsm_done={res.data.data.is_dsm}
                  mhe_done={res.data.data.is_mhe}
                  theraphy_done={res.data.data.is_theraphy}
                  doctor_referral_done={res.data.data.doctor_referral}
                  protective_factor_done={res.data.data.is_pf}
                  dot_done={res.data.data.is_dot}
                  sos_done={res.data.data.is_sos}
                  diagnosis_done={res.data.data.is_diagnosis}
                  caseFormulation1_done={res.data.data.is_case_formulation1}
                  caseFormulation2_done={res.data.data.is_case_formulation2}
                  prescription_required_done={
                    res.data.data.is_prescription_required
                  }
                  prescription_report_done={
                    res.data.data.is_prescription_report
                  }
                  followupConsultation={res.data.data.is_followup_consultation}
                  doctor_description={res.data.data.is_doctor_description}
                  concog={res.data.data.is_concog}
                  confas={res.data.data.is_confas}
                  conpsyq={res.data.data.is_conpsyq}
                  patient_id={this.props.location.state.pat_identity}
                  patientEvaluated={
                    this.state.consultation_info.patientEvaluated
                  }
                  is_stress={res.data.data.is_stress}
                  is_geriatric={res.data.data.is_geriatric}
                  is_psychiatry_fb={res.data.data?.is_psychiatry_fb}
                  is_psychiatry_fb_report={
                    res.data.data?.is_psychiatry_fb_report
                  }
                  is_tpn={res.data.data?.is_tpn}
                />
                <div className="finish-btns video-finish-btn">
                  <button
                    className="action-no"
                    onClick={this.closeConsultation}
                  >
                    {CONSTANTS.YES}
                  </button>
                  <button
                    className="action-yes"
                    onClick={() => utils.Modal(false)}
                  >
                    {CONSTANTS.NO}
                  </button>
                </div>
              </div>
            </div>
          ),
        });
      });
  };

  renderContent = (key, data) => {
    switch (key) {
      case "Case Sheets":
        return (
          <>
            <CaseNotes
              handleFunction={(data) =>
                this.setState({
                  is_casenotes: data?.is_casenotes || false,
                })
              }
              update_data={this.state.is_update}
              is_casesheet={this.state.is_casesheet}
              data={this.state.consultation_info}
              appointment_id={this.props.location.state?.roomName}
              type={this.props.location?.state?.user_type}
              formAction={this.formAction}
              form_action={this.state.form_action}
              patient_id={this.props.location.state.pat_identity}
            />
          </>
        );

      case "Diagnosis":
        return (
          <>
            <Diagnosis
              formAction={this.formAction}
              data={this.state.consultation_info}
              {...this.props}
              handleFunction={(data) =>
                typeof this.props.handleFunction == "function" &&
                this.props.handleFunction(data)
              }
            />
          </>
        );

      case "Prescription":
        return (
          <div>
            <PrescriptionTab
              disablePrescription={this.disablePrescription}
              prescription_enable={this.state.prescription_enable}
              formAction={this.formAction}
              form_action={this.state.form_action}
              data={this.state.consultation_info}
              prescription_done={this.state.is_prescription_done}
              is_prescription_required={this.state.is_prescription_required}
              is_prescription_report={this.state.is_prescription_report}
              is_prescription_publish_status={
                this.state.is_prescription_publish_status || ""
              }
              prescriptionValue={this.state.prescriptionValue}
              appointment_id={this.props.location.state.roomName}
              patient_id={this.props.location.state.pat_identity}
              handleFunction={(data) =>
                this.setState({
                  is_prescription: data?.is_prescription || false,
                  is_prescription_required:
                    data?.is_prescription_required == false ? false : true,
                })
              }
            />
          </div>
        );

      case "Follow Up":
        return (
          <div>
            {this.state.followupConsultationData ? (
              <div className="follow-up-title">Followup Appointment</div>
            ) : (
              <Radio.Group
                onChange={(e) => this.onConsultationRadioChange(e)}
                value={this.state.consultationValue}
                disabled={!this.state.autoNoConsultation}
                style={{ margin: "0px  0px 21px 21px" }}
              >
                <Space direction="vertical">
                  <Radio value={1}>No further appointment is required</Radio>
                  <Radio value={2}>Schedule next appointment</Radio>
                </Space>
              </Radio.Group>
            )}

            <FollowUp
              data={this.state.consultation_info}
              doc_api_id={this.props.location.state.doc_api_id}
              appointment_id={this.props.location.state.roomName}
              formAction={this.formAction}
              autoNoConsultation={this.state.autoNoConsultation}
              handleAutoNoConsultation={this.handleAutoNoConsultation}
              remoteUser={this.props.location.state.remoteusr}
              consultationValue={this.state.consultationValue}
              appointment_date={this.props.location.state.appointment_date}
              patientOffSet={this.props.location.state.patient_off_set}
              patient_id={this.props.location.state.pat_identity}
              oneSessionPlan={
                this.state.consultation_info.patientEvaluated == false ||
                !this.state.consultation_info.is_multiple_session
                  ? true
                  : false
              }
            />
          </div>
        );

      case "Doctor Referral":
        return (
          <div>
            <DoctorReferral
              data={this.state.consultation_info}
              appointment_id={this.props.location.state?.roomName}
              type={this.props.location?.state?.user_type}
              is_doctor_referral={this.state.is_doctor_referral}
              form_action={this.state.form_action}
              formAction={this.formAction}
            />
          </div>
        );
      case "Stress":
        return (
          <>
            <Stress
              data={this.state.consultation_info}
              formAction={this.formAction}
              form_action={this.state.form_action}
            />
          </>
        );
      case "vital":
        return (
          <>
            <VitalFormDoctorAtConsultation
              data={{
                ...this.state.consultation_info,
                patient_id: this.props.location.state.pat_identity,
              }}
              formAction={this.formAction}
              form_action={this.state.form_action}
            />
          </>
        );
    }
  };

  publishDataTrack() {
    // const dataTrack = new LocalDataTrack();
    // this.state.room.localParticipant.publishTrack(dataTrack);
  }

  updateRmtprtcpSts() {
    this.setState({ isRmtPrtcptJoined: true });
  }

  handleAutoNoConsultation = (value) => {
    this.setState({ autoNoConsultation: value });
  };
  unsavedPopup = ({ key, isDrawer = false }) => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  if (isDrawer) {
                    this.toggleDrawerForm();
                  }
                  this.handleTabSelection({ key }), utils.Modal(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  handleTabSelection = ({ key }) => {
    this.getConsultationStatus();
    this.setState({
      tabLabel: key,
    });
    // scrollIntoView(document.getElementById(`tab-content`));
  };

  render() {
    const description = ["", "Terrible", "Bad", "Normal", "Good", "Wonderful"];
    return (
      <>
        {this.state.loading ? (
          <Loader />
        ) : (
          <div
            className={
              this.props.location.state.is_doctor
                ? "video-consultation-wrapper"
                : "video-consultation-wrapper-2"
            }
          >
            <div ref={this.videoCont}>
              <Row className="" gutter={16}>
                {this.state.consultation_info?.is_video_call ? (
                  <>
                    <Col
                      className={
                        "gutter-row " +
                        // (this.state.showChat ? "expand-vc" : "collapse-vc")
                        ""
                      }
                      xs={24}
                      // md={17}
                      md={this.state.showChat ? 24 : 17}
                    >
                      {!this.state.isMeetingActive &&
                      this.state?.consultation_info?.is_video_call ? (
                        <></>
                      ) : (
                        <>
                          {/* <ChimeMeetingPanel
                            is_doctor={this.props.location.state?.is_doctor}
                            meetingData={this.props.location.state.meetingData}
                            attendeeData={
                              this.props.location.state.attendeeData
                            }
                            returnToLobby={this.returnToLobby}
                          /> */}
                          <ChimeVideoConsultationVideoChild
                            meetingData={this.state.meetingData}
                            attendeeData={this.state.attendeeData}
                            returnToLobby={this.returnToLobby}
                            // room={this.state.room}
                            videocallDetails={this.props?.location?.state}
                            remoteusr={this.props.location.state.remoteusr}
                            is_doctor={this.props.location.state.is_doctor}
                            patient_id={this.props.location.state.pat_identity}
                            toggleChat={this.toggleChat}
                            showChat={this.state.showChat}
                            minvideoVisible={this.state.minvideoVisible}
                            updateRmtprtcpSts={this.updateRmtprtcpSts.bind(
                              this
                            )}
                            is_video_call={
                              this.state.consultation_info?.is_video_call
                            }
                            is_show_ai_form={this.state.is_show_ai_form}
                            toggleAIForm={this.toggleAIForm}
                            patientDetail={{
                              user_type:
                                this.state?.consultation_info.user_type,
                              gender: this.state?.consultation_info.gender,
                              age: this.state?.consultation_info.age,
                            }}
                            toggleDrawerForm={this.toggleDrawerForm}
                          />
                        </>
                      )}
                    </Col>

                    {/* Chat block */}
                    <Col
                      className={
                        "gutter-row " +
                        (this.state.showChat ? "alignLast" : "show-chat") +
                        (this.state.showChat ? " hide-chat" : "")
                      }
                      style={{ display: "flex", flexDirection: "column" }}
                      xs={24}
                      md={7}
                    >
                      {!this.state.isMeetingActive ? (
                        <></>
                      ) : (
                        <>
                          <div className="chat-container-div">
                            {/* <div
                              className={this.state.showChat ? "hide-chat" : ""}
                            >
                              <div className="d-flex justify-content-between position-relative">
                                <div>
                                  <div>
                                    {this.props.location.state.is_doctor ===
                                    true ? (
                                      <>
                                        {this.state.showChat ? (
                                          <div className="chat-div">
                                            <Button onClick={this.toggleChat}>
                                              Chat{" "}
                                            </Button>
                                          </div>
                                        ) : null}
                                      </>
                                    ) : (
                                      <>
                                        <h4 className="m-3">
                                          {utils.FirstNameLastName(
                                            utils.FormatName(
                                              utils.getDisplayName(
                                                this.props.location.state
                                                  .remoteusr,
                                                this.props.location.state
                                                  .remoteUserLastName
                                              )
                                            ),
                                            "200px"
                                          )}
                                        </h4>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div> */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                flex: 1,
                              }}
                            >
                              {/* <VideoConsultationChatChild
                          identity={this.props.location.state.identity}
                          roomName={this.props.location.state.roomName}
                          token={this.props.location.state.token}
                          localusr={this.props.location.state.localusr}
                          remoteusr={this.props.location.state.remoteusr}
                          appDate={this.props.location.state?.appointment_date}
                          is_doctor={this.props.location.state.is_doctor}
                          toggleChat={this.toggleChat}
                        /> */}

                              {this.props.location.state?.is_doctor && (
                                <ChimeSpeechToAIForm
                                  patient_id={
                                    this.props.location.state.pat_identity
                                  }
                                  appointment_id={
                                    this.props.location.state?.roomName
                                  }
                                  appointment_date_time={
                                    this.props.location.state
                                      ?.appointment_utc_date_time
                                  }
                                  visible={this.state.is_show_ai_form}
                                  toggleDrawer={this.toggleAIForm}
                                  patient_last_name={
                                    this.props?.location?.state
                                      .remoteUserLastName
                                  }
                                  patient_name={
                                    this.props.location.state.remoteUserName
                                  }
                                  patient_age={
                                    this.state?.consultation_info.age
                                  }
                                  patient_gender={
                                    this.state?.consultation_info.gender
                                  }
                                  meetingData={this.state.meetingData}
                                />
                              )}
                              <div
                              // style={{
                              //   display: !this.state.is_show_ai_form
                              //     ? "block"
                              //     : "none",
                              // }}
                              >
                                <VideoConsultationConversation
                                  identity={this.props.location.state.identity}
                                  rmt_prtcp_id={
                                    this.props.location.state.rmt_prtcp_id
                                  }
                                  localUserName={
                                    this.props.location.state.localUserName
                                  }
                                  remoteUserName={
                                    this.props.location.state.remoteUserName
                                  }
                                  roomName={this.props.location.state.roomName}
                                  token={this.props.location.state.token}
                                  localusr={this.props.location.state.localusr}
                                  remoteusr={
                                    this.props.location.state.remoteusr
                                  }
                                  appDate={
                                    this.props.location.state?.appointment_date
                                  }
                                  appointment_utc_date_time={
                                    this.props.location.state
                                      ?.appointment_utc_date_time
                                  }
                                  is_doctor={
                                    this.props.location.state.is_doctor
                                  }
                                  toggleChat={this.toggleChat}
                                  showChat={this.state.showChat}
                                  isRmtPrtcptJoined={
                                    this.state.isRmtPrtcptJoined
                                  }
                                  reloadRmtPrtcptConvo={
                                    this.state.reloadRmtPrtcptConvo
                                  }
                                  publishDataTrack={this.publishDataTrack.bind(
                                    this
                                  )}
                                />
                              </div>
                              {/* {this.props.location.state?.is_doctor ? (
                          <>
                            {" "}
                            <Button
                              onClick={this.finishConsultation}
                              className="finish_Consultation-icon"
                              icon={
                                <img
                                  className="finish-btn-icon"
                                  src={icons.new_dash_tick_circle}
                                />
                              }
                            />
                         
                          </>
                        ) : null} */}
                            </div>
                          </div>
                        </>
                      )}
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>
              {this.props.location.state?.is_doctor ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "baseline",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        alignItems: "baseline",
                        display: "flex",
                        justifyContent: "space-between",
                        width: "90%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "baseline",
                        }}
                      >
                        {/* <p
                          style={{
                            font: "bold",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {utils.FirstNameLastName(
                            utils.FormatName(
                              utils.getDisplayName(
                                this.state.consultation_info.remoteUser,
                                this.props?.location?.state.remoteUserLastName
                              )
                            ),
                            "250px"
                          )}{" "}
                          <span className="pipeline-color">|</span>{" "}
                          {utils.ConvertToPascalCase(
                            this.state?.consultation_info.user_type
                          )}{" "}
                          <span className="pipeline-color">|</span>{" "}
                          {utils.FormatName(
                            this.state?.consultation_info.gender
                          )}
                          , {this.state?.consultation_info.age} years
                        </p> */}
                        <h4 className="m-3 ">
                          <Link
                            className="text-underline"
                            onClick={() => {
                              localStorage.setItem(
                                "patient_id",
                                this.props.location.state.pat_identity || ""
                              );
                            }}
                            to={{
                              pathname: "/doctor/health-profile",
                            }}
                            target="_blank"
                          >
                            View Health Information{" "}
                          </Link>{" "}
                        </h4>
                      </div>
                    </div>
                    {!this.state.isMeetingActive ? (
                      this.props.location.state?.is_doctor && this._isJoined ? (
                        <>
                          <Button
                            className="video-rejoin-btn"
                            onClick={(e) => {
                              this.reJoin();
                            }}
                            icon={<ArrowLeftOutlined />}
                          >
                            {" "}
                            Rejoin Consultation{" "}
                          </Button>
                        </>
                      ) : null
                    ) : null}
                    <>
                      {/* <Button
                     onClick={this.finishConsultation}
                     className="finish_Consultation-icon"
                   /> */}
                      <Button
                        onClick={this.finishConsultation}
                        className="video-rejoin-btn"
                        icon={<CheckOutlined />}
                      >
                        Finish Consultation
                      </Button>
                    </>
                  </div>
                  <Divider style={{ margin: "0px", width: "80%" }} />{" "}
                </div>
              ) : null}
            </div>

            <>
              {this.props.location.state?.is_doctor ? (<>
                {this.state.isMeetingActive ? (<Drawer
                  open={this.state.is_show_drawer}
                  width={"60vw"}
                  onClose={() => {
                    if (this.state.form_action) {
                      this.unsavedPopup({ key: "", isDrawer: true });
                    } else {
                      this.toggleDrawerForm();
                    }
                  }}
                  className="consultation-form-drawer"
                >
                  {/* <Row gutter={24}>
                    <Col span={24}> */}
                      <div>
                        {this.state.tabLabel ? (
                          <div className="form-content-main-menu">
                          <div className="form-content-header">
                            <Button
                              className="back-to-form-home"
                              onClick={() => {
                                this.state.form_action
                                  ? this.unsavedPopup("")
                                  : this.handleTabSelection("");
                              }}
                            >
                              <span>{`< Back`}</span>
                            </Button>
                            <div>{`Form Menu / ${this.state.tabLabel.replace(/\b\w/g, char => char.toUpperCase())}`}</div>
                            </div>
                            <Card className="main-content-card">
                              {this.renderContent(this.state.tabLabel)}
                            </Card>
                          </div>
                        ) : (
                          <div className="form-main-menu">
                            <div>Provide all necessary details</div>
                            <Card style={{width:"50%"}}>
                              <Menu
                                // defaultSelectedKeys={["vital"]}
                                mode="inline"
                                selectedKeys={[`${this.state.tabLabel}`]}
                                onSelect={this.handleTabSelection}
                                items={this.state.ButtonLists.map((item,index) => ({
                                  icon:this.state[item.apikey]?<RoundcheckGreen/>: <Roundcheck/>,
                                  ...item,
                                }))}
                              />
                            </Card>
                          </div>
                        )}
                      </div>
                    {/* </Col>
                  </Row> */}
                </Drawer>):(
                <>
                  <Row gutter={24}>
                    <Col className="gutter-row tab-container" span={24}>
                      <></>
                      <div className="carousel-content">
                        <Layout className="consultation-layout-container">
                          <Sider className="sider-video-consultation">
                            <Menu
                              // defaultSelectedKeys={["Case Sheets"]}
                              defaultSelectedKeys={["vital"]}
                              mode="inline"
                              selectedKeys={[`${this.state.tabLabel ||"vital" }`]}
                              onSelect={this.state.form_action?this.unsavedPopup:this.handleTabSelection}
                              items={this.state.ButtonLists}                           
                            />
                          </Sider>
                          <Content className="consultation-layout-content">
                            <div className="tab-content" id="tab-content">
                              {this.renderContent(this.state.tabLabel||"vital")}
                            </div>
                          </Content>
                        </Layout>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
                </>
              ) : (
                <></>
              )}              
            </>
            <Modal
              open={this.state.isModalVisible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              maskClosable={false} // This prevents clicking outside the modal to close it
              // title = {this.props.location?.state?.is_doctor ? <></> : <>Feedback form</>}
              closable={this.props.location?.state?.is_doctor ? true : false}
              footer={
                this.props.location?.state?.is_doctor
                  ? [
                      <div className="video-completed-done-btn-container">
                        <Button
                          key="link"
                          type="primary"
                          onClick={this.handleOk}
                          className="video-completed-done-btn"
                        >
                          Done
                        </Button>
                      </div>,
                    ]
                  : null
                // [
                // <div className="submit-cancel-button">
                // <Button className="cancel-btn" key="back" onClick={this.handleCancel}>
                //   Cancel
                // </Button>,
                // <Button className="update-btn" key="submit" type="primary" onClick={this.handleOk}>
                //   Submit
                // </Button>
                // </div>
                // ]
              }
            >
              {this.props.location?.state?.is_doctor ? (
                <div className="call-duration-ended-cotent">
                  <h4 className="text-center">
                    Video Consultation has ended with{" "}
                    {this.props.location?.state?.is_doctor === true ? (
                      <>
                        {utils.FormatName(
                          utils.getDisplayName(
                            this.props.location.state.remoteusr,
                            this.props.location.state.remoteUserLastName
                          )
                        )}
                      </>
                    ) : (
                      <>
                        {utils.FormatName(
                          this.props.location?.state?.remoteusr
                        )}
                      </>
                    )}
                  </h4>
                  <p className="text-center">
                    Call Duration: {this.state.totalDuration}
                  </p>
                </div>
              ) : (
                <div className="finish-Consult-Modal-patient">
                  <div className="finish-header">{CONSTANTS.FEEDBACK_FORM}</div>
                  <div className="call-duration-ended-cotent">
                    <Form
                      ref={this.form}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      labelAlign="left"
                      onFinish={this.handleSubmitFeedback.bind(this)}
                    >
                      <Form.Item
                        rules={[
                          { required: true, message: "Please provide rating" },
                        ]}
                        label={CONSTANTS.CLINICAL_RATING}
                        name="feedback_rating"
                      >
                        <div className="rating-description">
                          <Rate
                            onChange={this.handleClinicalRatingsChange}
                            count={5}
                            allowClear
                            value={this.state.clinicalRatingValue}
                          />
                          {this.state.clinicalRatingValue > 0 && (
                            <span>
                              {
                                description[
                                  Math.ceil(this.state.clinicalRatingValue)
                                ]
                              }
                            </span>
                          )}
                        </div>
                      </Form.Item>
                      <Form.Item
                        rules={[
                          { required: true, message: "Please provide rating" },
                        ]}
                        label={CONSTANTS.CALL_RATING}
                        name="call_rating"
                      >
                        <div className="rating-description">
                          <Rate
                            onChange={this.handleCallRatingsChange}
                            count={5}
                            allowClear
                            value={this.state.callRatingValue}
                          />
                          {this.state.callRatingValue > 0 && (
                            <span>
                              {
                                description[
                                  Math.ceil(this.state.callRatingValue)
                                ]
                              }
                            </span>
                          )}
                        </div>
                      </Form.Item>
                      <Form.Item
                        rules={[
                          { required: false },
                          Validators.checkValidComments,
                        ]}
                        label={CONSTANTS.COMMENTS}
                        name="comment"
                      >
                        <Input.TextArea
                          onChange={(e) => this.handleComment(e)}
                          rows={2}
                          maxLength={255}
                          value={this.state.comments}
                        />
                      </Form.Item>
                      <div className="submit-cancel-button">
                        {/* <Button
                          disabled={
                            !(
                              this.state.callRatingValue > 0 &&
                              this.state.clinicalRatingValue > 0
                            )
                          }
                          className={
                            this.state.callRatingValue > 0 &&
                            this.state.clinicalRatingValue > 0
                              ? "update-btn"
                              : "update-btn-disable"
                          }
                          htmlType="submit"
                          loading={this.state.feebackBtnLoading}
                        >
                          {CONSTANTS.SUBMIT}
                        </Button> */}
                        <CommonButton
                          disabled={
                            !(
                              this.state.callRatingValue > 0 &&
                              this.state.clinicalRatingValue > 0
                            )
                          }
                          label={CONSTANTS.SUBMIT}
                          htmlType="submit"
                          className="common-button-green"
                          loading={this.state.feebackBtnLoading}
                        />
                        {/* <Button
                          className="cancel-btn"
                          key="back"
                          onClick={this.handleCancel}
                        >
                          {CONSTANTS.CANCEL}
                        </Button> */}
                        <CommonButton
                          className="common-button-white"
                          key="back"
                          onClick={this.handleCancel}
                          label={CONSTANTS.CANCEL}
                        />
                      </div>
                    </Form>
                  </div>
                </div>
              )}
            </Modal>
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    submittedDetails: state.videoConsultationReducer.prescriptionDone,
    chat_count: state.patientDetailReducer?.chat_count,
    prescriptions: state.videoConsultationReducer.prescriptions,
    switch_vc_tabs: state.tabsReducer.switch_vc_tabs,
    switch_casesheet: state.tabsReducer.switch_casesheet_tabs,
    switch_stress: state.tabsReducer.switch_stress_tabs,
    switch_prescription: state.tabsReducer.switch_prescription_tabs,
    current_tab: state.tabsReducer.current_tab,
    current_prescription_tab: state.tabsReducer.current_prescription_tab,
    switch_stress: state.tabsReducer.switch_stress_tabs,
  };
};
const mapDispatchToProps = {
  setPrescriptionDone,
  setMinvideoVisible,
  setVideoFullScreen,
  setPrescriptions,
  switchVCTab,
  currentTab,
  setUpdateData,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ChimeVideoConsultation);
